import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alerta-accion-irreversible',
  templateUrl: './alerta-accion-irreversible.component.html',
  styleUrls: ['./alerta-accion-irreversible.component.css']
})
export class AlertaAccionIrreversibleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
